import { Map } from 'immutable'
import { useContext, createContext } from 'react'

export const ExconSettingsContext = createContext(Map())

export const useExconSettingsContext = () => useContext(ExconSettingsContext)
